import { cerrarSesion } from "../utilities/Seguridad";
import axios from "axios";
import moment from 'moment';
const FormData = require("form-data");

export async function getListaOtrosFormularios(idColegio, anio, token, keyFormulario) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/otros-formularios/listar/${idColegio}/${anio}`,
        headers: {
            Authorization: `Bearer ${token}`,
            formulario: keyFormulario,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function crearOtrosFormulario(token, id, keyFormulario) {
    let data = new FormData();
    data.append("id", id);
    data.append("formulario", keyFormulario);

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/otros-formularios/crear`,
        headers: {
            Authorization: `Bearer ${token}`,
            formulario: keyFormulario,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function copyDocumento(token, id, keyFormulario) {
    let data = new FormData();
    data.append("id", id);
    data.append("formulario", keyFormulario);

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/otros-formularios/copiar`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function uploadDocumentoOtros(token, id, keyFormulario, path) {
    let data = new FormData();
    data.append("id", id);
    data.append("formulario", keyFormulario);
    data.append("archivo", path);

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/otros-formularios/subir`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function cerrarFormulario(token, id) {
    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/otros-formularios/cerrar/${id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function eliminarOtrosFormulario(token, id) {
    let config = {
        method: "delete",
        url: `${process.env.REACT_APP_URL}/otros-formularios/eliminar/${id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function setMedico(token, medico, es_otro, add) {

    let data = new FormData();
    data.append("data", "[" + medico.data + "]");
    data.append("nombres", medico.nombres);
    data.append("rut", medico.rut);
    data.append("nro_reg_prof", medico.nro_reg_prof);
    data.append("especialidad", medico.especialidad);
    data.append("procedencia", es_otro ? add : medico.procedencia);
    data.append("fono_email", medico.fono_email);
    data.append("fecha_eval", moment(medico.fecha_eval).format("YYYY-MM-DD"));
    data.append("fecha_rev", moment(medico.fecha_rev).format("YYYY-MM-DD"));

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/otros-formularios/salud-medico`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function getDataRevTemplanteMasivo(token, idColegio, anio, key_formulario, data_ids) {

    let data = new FormData();
    data.append("ids", data_ids);
    data.append("formulario", key_formulario);

    let config = {
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/otros-formularios/${idColegio}/descarga-masiva/${anio}`,
        headers: {
            'Authorization': `Bearer ${token}`
        },
        data: data,
    };
    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

export async function uploadDocumentoPDFMasivoOtros(token, idColegio, anio, keyFormulario, path) {
    let data = new FormData();
    data.append("formulario", keyFormulario);
    data.append("data", path);

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/otros-formularios/${idColegio}/cargarPdf/${anio}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}


export async function statusDocumentoPDFMasivoOtros(token, idColegio, anio, keyFormulario) {

    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/otros-formularios/${idColegio}/estado-carga/${anio}`,
        headers: {
            Authorization: `Bearer ${token}`,
            formulario: keyFormulario,
        }
    }

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
}

